<template>
  <div class="content">
    <div :class="{bg: true,empty: list.length === 0}">
      <div class="batch">
        <img :src="checkedAll ? checkerOn : checker" class="checker" alt="checker" @click="selectAllChecker()">
        <div class="bigBtn greenBtn" @click="approveChecks()">
          批量通过
        </div>
        <div class="bigBtn" @click="banChecks()">
          批量退回
        </div>
      </div>
      <div class="headline">
        <div class="titles">
          <!-- <img :src="checker" class="checker" alt="checker"> -->
          <span class="topic">主题</span>
          <span class="reporter">记者</span>
          <span class="locate">地点</span>
          <span class="startEnd">开始／结束时间</span>
          <span class="publish">发布时间</span>
          <span class="handles">操作</span>
        </div>
      </div>
      <empty :mTop="30" :msg="`暂无${$_syscfg.interview}数据`" v-if="list && list.length === 0" />
      <div class="items" v-for="(i, d) in list" :key="d">
        <div class="item">
          <img :src="i.checked? checkerOn :checker" class="checker" alt="checker" @click="selectChecker(i)">
          <div class="topic">
            <p class="words" @click="goDetail(i.id)" :title="i.title">
              {{i.title}}
            </p>
            <span class="msgIcon" v-if="i.remark">
              <img src="@assets/img/interview/msg.svg" alt="msg">
              <p class="msgContent">
                {{i.remark}}
              </p>
            </span>
            <img src="@assets/img/interview/new.svg" alt="new" v-if="i.is_new == 1">
            <img src="@assets/img/interview/alert.svg" alt="warn" v-if="i.has_change - 0 === 1">
          </div>
          <div class="reporter">
            <!-- {{i.reporters.map(j => {return j.name}).join(',')}} -->
            <span class="card" v-for="(r, rd) in i.reporters" :key="rd" @click="showCard(r.id, $event)">
              {{r.name}}{{rd===i.reporters.length-1?'':','}}
            </span>
          </div>
          <div class="locate">{{i.address}}</div>
          <div class="startEnd">
            <span>{{i.start}}</span>
            <span>{{i.end}}</span>
          </div>
          <div class="publish">{{i.raw_add_time}}</div>
          <div class="handles">
            <span class="smallBtn" @click="goEdit(i.id)">编辑</span>
            <span class="smallBtn greenBtn" @click="handleInterviews([i.id], 0)">通过</span>
            <span class="smallBtn" @click="handleInterviews([i.id], 1)">退回</span>
          </div>
        </div>
      </div>
      <pages :page_count="page.page_count" :index="page.pageIndex" :total="page.total"></pages>
    </div>
  </div>
</template>

<script>
import pages from '@components/pages'
import common from '@common/common'
import {apis} from '@common/config'
import empty from '@components/empty'

export default {
  name: 'checkInterviews',
  components: {
    pages, empty
  },
  data() {
    return {
      page: {
        page_count: 0,
        pageSize: 10,
        pageIndex: 1,
        total: 0
      },
      checkedAll: false,
      checker: require('@assets/img/interview/checker.svg'),
      checkerOn: require('@assets/img/interview/checkerOn.svg'),
      list: [],
      searchOptions: {}
    }
  },
  methods: {
    showCard(id, e) {
      if (id == 0) return

      const el = e.target

      this.$card(id, el)
    },
    async goEdit(i) {
      const newWindow = window.open()
      common.checkPageStatus(i, 0).then(r => {
        if (r) {
          newWindow.location.href = `${window.location.origin}/editInterview?r=${i}`
        } else {
          newWindow.close()
        }
      })
    },
    goDetail(i) {
      // this.$router.push({
      //   path: '/interviewCheck',
      //   query: {
      //     r: i,
      //     c: 't'
      //   }
      // })

      common.jump(`/interviewCheck?r=${i}&c=t`, true)
    },
    getList(keyWord) {
      const id = this.$route.params.id
      const info = {
        idstring: id,
        search_option: '',
        key_words: '',
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      }

      if(keyWord == 'noKeyWord'){
        this.searchOptions.key_words = ''
      }else{  
        this.searchOptions.key_words = this.$store.state.keyWord
      }

      Object.assign(info, this.searchOptions)
      common.myFetch(apis.Itv_check_interviews, info)
      .then((data) => {
        this.list = data.list
        this.generateSearchs(data.params.top_search.option.list)
        this.$set(this.page, 'page_count', common.calculatePage(data.page.row_count - 0, this.page.pageSize))
        this.$set(this.page, 'total', data.page.row_count - 0)
      })
    },
    generateSearchs(data) {
      const types = data.map((i) => {
        return {
          name: i.title,
          code: i.key,
          selected: i.selected
        }
      })

      const filterData = {
        types: types,
        callback: (o) => {
          this.getSearch(o)
        }
      }

      this.postSearch(filterData)
    },
    getSearch(d) {
      this.searchOptions = d
      this.page.pageIndex = 1
      this.getList()
    },
    postSearch(data) {
      this.$emit('filterData', data)
    },
    selectChecker(i) {
      this.$set(i, 'checked', !i.checked)
    },
    selectAllChecker() {
      this.list.forEach((i) => {
        this.$set(i, 'checked', !this.checkedAll)
      })
      this.checkedAll = !this.checkedAll
    },
    async handleInterviews(ids, status) {
      let msg = '确认通过吗？'
      if (status === 1) {
        msg = '确认退回吗？'
      }
      const c = await this.$confirm(msg)
      if (!c) return

      const info = {
        iview_id: ids.join(','),
        status: status
      }

      common.myFetch(apis.Itv_handle_interviews, info)
      .then((data) => {
        if (data) {
          this.$toast(data)
          this.getList()
        }
      })
    },
    allChecks() {
      const selected = []
      this.list.forEach((i) => {
        if (i['checked']) {
          selected.push(i.id)
        }
      })

      return selected
    },
    banChecks() {
      const ids = this.allChecks()
      this.handleInterviews(ids, 1)
    },
    approveChecks() {
      const ids = this.allChecks()
      this.handleInterviews(ids, 0)
    }
  },
  mounted() {
    this.getList('noKeyWord')
  }
}
</script>

<style lang="less" src="@assets/css/interview/checkInterviews.less" scoped></style>
